export default __webpack_public_path__ + "static/media/Octavia_E_Vance_AHV_In_Moms_We_Trust.8a10d472.jpg";